<ng-container *ngIf="ui.viewportSize$ | async as viewportSize">
    <div class="row gx-2 gy-3 justify-content-between align-items-center mb-3">
        <div class="col-3 col-md-auto" *ngIf="showPeriodSelector">
            <mat-form-field
                appearance="fill"
                *ngIf="viewportSize === 'xs' || viewportSize === 'sm'"
            >
                <mat-label>Range</mat-label>
                <mat-select
                    (selectionChange)="setPeriod($event.value)"
                    [value]="(period$ | async).name"
                    [compareWith]="isSelected"
                >
                    <mat-option *ngFor="let option of periods" [value]="option">
                        {{ option.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="group" *ngIf="viewportSize !== 'xs' && viewportSize !== 'sm'">
                <button
                    *ngFor="let option of periods"
                    class="btn btn-sm secondary"
                    role="option"
                    [class.active]="(period$ | async).name === option.name"
                    [attr.aria-selected]="(period$ | async).name === option.name || null"
                    (click)="setPeriod(option)"
                >
                    <tabler-icon
                        name="calendar"
                        *ngIf="option.name === 'Custom'"
                        style="height: 16px; width: 16px"
                        class="my-n2 me-1"
                    ></tabler-icon>
                    <span [class.visually-hidden]="option.name === 'Custom'">
                        {{ option.name }}
                    </span>
                </button>
            </div>
        </div>
        <div class="col-3 col-md-auto" *ngIf="showScaleSelector">
            <mat-form-field
                appearance="fill"
                *ngIf="viewportSize === 'xs' || viewportSize === 'sm'"
            >
                <mat-label>Scale</mat-label>
                <mat-select
                    (selectionChange)="setScale($event.value)"
                    [value]="scale$ | async"
                >
                    <mat-option *ngFor="let option of scale" [value]="option.value">
                        {{ option.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="group" *ngIf="viewportSize !== 'xs' && viewportSize !== 'sm'">
                <button
                    *ngFor="let option of scale"
                    class="btn btn-sm secondary"
                    role="option"
                    [class.active]="(scale$ | async) === option.value"
                    [attr.aria-selected]="(scale$ | async) === option.value || null"
                    (click)="setScale(option.value)"
                >
                    {{ option.name }}
                </button>
            </div>
        </div>
        <ng-container *ngIf="period$ | async as period">
            <div
                class="col-12 col-md-8 mt-4 order-md-3 order-xl-4"
                *ngIf="period.showDateSelector === true"
            >
                <form
                    class="row gx-2 mt-sm-n2 mb-n3 mb-sm-n4"
                    [formGroup]="reactiveForm"
                    autocomplete="off"
                >
                    <div class="col-6 col-sm-3 col-md-auto">
                        <mat-form-field appearance="fill" class="sb-datepicker-field">
                            <mat-label>From</mat-label>
                            <input
                                matInput
                                [matDatepicker]="fromDateRef"
                                formControlName="fromDate"
                            />
                            <mat-datepicker-toggle matSuffix [for]="fromDateRef">
                                <i-tabler
                                    matDatepickerToggleIcon
                                    name="calendar"
                                    style="height: 32px; width: 20px"
                                ></i-tabler>
                            </mat-datepicker-toggle>
                            <mat-datepicker #fromDateRef></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-6 col-sm-3 col-md-auto">
                        <mat-form-field appearance="fill" class="sb-datepicker-field">
                            <mat-label>To</mat-label>
                            <input
                                matInput
                                [matDatepicker]="toDateRef"
                                formControlName="toDate"
                            />
                            <mat-datepicker-toggle matSuffix [for]="toDateRef">
                                <i-tabler
                                    matDatepickerToggleIcon
                                    name="calendar"
                                    style="height: 32px; width: 20px"
                                ></i-tabler>
                            </mat-datepicker-toggle>
                            <mat-datepicker #toDateRef></mat-datepicker>
                            <mat-error
                                *ngIf="reactiveForm.getError('invalidDate', 'toDate')"
                            >
                                To date have to be greater than from date
                            </mat-error>
                        </mat-form-field>
                    </div>
                </form>
            </div>
        </ng-container>
    </div>
    <div class="row col-12 order-last">
        <div class="col-10">
            <app-bb-chart
                [options]="(chartConfig$ | async)?.options"
                [data]="(chartConfig$ | async)?.data"
                [loading]="loading"
                (chartRef)="chartRef = $event"
            >
                <div
                    class="skeleton-loader skeleton-loader-chart-area"
                    aria-busy="true"
                ></div>
            </app-bb-chart>
        </div>
        <div class="col-2">
            <!--<div class="info-box">
                <p>Current Total</p>
                <span class="value-1">{{ currentTotalMarketValue }}</span>
            </div>-->
            <div class="info-box">
                <p>Absolute Change</p>
                <span class="value-2">{{ absoluteChange }}</span>
            </div>
        </div>
        <!-- TODO: replace with new pro tip component once merged -->
        <div
            role="alert"
            class="info mx-auto mt-0"
            style="width: fit-content"
            *ngIf="showDateNotice"
        >
            <header>
                <h3 class="h4 mb-1">Showing Market Value Over Time since inception</h3>
                <button
                    class="close"
                    type="button"
                    (click)="showDateNotice = false"
                ></button>
            </header>
            Chart shows Market Value Over Time since first known transaction
            {{ minDate | date : 'shortDate' }}.
        </div>
    </div>
</ng-container>
